import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ViewChild } from '@angular/core';
// used to create fake backend
// import { fakeBackendProvider } from './_helpers';
import {DragDropModule} from '@angular/cdk/drag-drop';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home';
import { LoginComponent, DialogExampleRestaurar } from './users/login';
import { RegisterComponent } from './register';
import { ListComponent } from './list/list.component';
import { StatusFfComponent } from './status-ff/status-ff.component';
import { SalesComponent } from './sales/sales.component';
import { ShopiAuthsComponent } from './shopi-auths/shopi-auths.component';
import { InvoicesComponent, DialogInvoice, InvoicesTab1, InvoicesTab2, InvoicesTab3 } from './navegacion/invoices/invoices.component';
import { TransactionsComponent } from './transactions';
import { CedunosComponent } from './cedunos';
import { CetresComponent } from './cetres';
import { CedosComponent } from './cedos';
import { BackofficeComponent } from './backoffice';
import { EntradasComponent, EntradasTab1, EntradasTab2, EntradasTab3, DialogGuia, DialogGuia2, DialogEntrada, DialogEditarEntrada, DialogFechaMasiva } from './navegacion/entradas/entradas.component';
import { FulfillmentsComponent, FulfillmentsTab1, FulfillmentsTab2, FulfillmentsTab3, FulfillmentsTab4, FulfillmentsTab5, DialogFf, DialogGuiaFF2, DialogGuiaFF3, DialogGuiaFF4,DialogGuiaFF5, DialogGuiaFF6 } from './navegacion/fulfillments/fulfillments.component';
import { InventariosComponent, InventariosTab1, InventariosTab2, InventariosTab3, DialogInventario, DialogBundle, DialogFormulario, InventariosTab4 } from './navegacion/inventarios/inventarios.component';
import { ReportsComponent, ReportsTab1, ReportsTab2, ReportsTab3, DialogReport } from './navegacion/reports/reports.component';
import { AccountsComponent, DialogAccount, AccountsTab1, AccountsTab2, AccountsTab3, AccountsTab4, DialogAltaCli, ClientesDialog4,AccountsTab5,DialogAltaUser,UsersDialog5,AccountsTab6,DialogAltaRoles,UsersDialog6,DialogPermisosRoles,DialogAltaBox,ClientesDialog5,AccountsTab8,DialogAltaCredential} from './navegacion/accounts/accounts.component';
import { IntegrationsComponent, DialogIntegration, IntegrationsTab1, IntegrationsTab2, IntegrationsTab3, DialogIntegration2, DialogIntegration3, DialogIntegration4, DialogIntegration5, DialogIntegration6  } from './navegacion/integrations/integrations.component';
import { SupportsComponent, SupportsTab1, SupportsTab2 } from './navegacion/supports/supports.component';
import { DevolucionsComponent, DevolucionsTab1, DevolucionsTab2, DialogDet1, Dialog2, DialogDetDevolucion, Dialog4, DialogImagenes} from './navegacion/devolucions/devolucions.component';
import { DevolutionsTab3 } from './navegacion/devolucions/devolutions-tab-3/devolutions-tab-3.component';
import { FormDataShipmentComponent } from './navegacion/devolucions/devolutions-tab-3/dialog-form-data-shipment.component';
import { TicketComponent, TicketsTab1, TicketsTab2, TicketsTab2Sub1, TicketsTab2Sub2, TicketsTab2Sub3, DialogDetTic1, DialogPreguntaDevolucion, DialogSubirGuia, DialogPreguntaFulfillment, DialogGuiaFF1, DialogGenerarFF, DialogPreguntaReabrir} from './navegacion/tickets/tickets.component';
import { DashboardsComponent, DialogConfiguracionGeneral } from './navegacion/dashboard/dashboards.component';

import { FormsModule, ReactiveFormsModule, FormControl } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS,HttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatTableModule} from '@angular/material/table';
import { MatFormFieldModule} from '@angular/material/form-field';
import { MatSidenavModule} from '@angular/material/sidenav';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatCheckboxModule} from '@angular/material/checkbox';
import { MatListModule} from '@angular/material/list';
import { MatDatepickerModule} from '@angular/material/datepicker';
import { MatInputModule} from '@angular/material/input';
import { MatMenuModule} from '@angular/material/menu';
import { MatRadioModule} from '@angular/material/radio';
import { MatSelectModule} from '@angular/material/select';
import { MatButtonModule} from '@angular/material/button';
import { MatButtonToggleModule} from '@angular/material/button-toggle';
import { MatGridListModule} from '@angular/material/grid-list';
import { MatSnackBarModule} from '@angular/material/snack-bar';
import { MatDialogModule} from '@angular/material/dialog';
import { MatTabsModule} from '@angular/material/tabs';
import { MatToolbarModule} from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule} from '@angular/material/icon';
import { MatDividerModule} from '@angular/material/divider';
import { MatTooltipModule} from '@angular/material/tooltip';
import { MatBadgeModule} from '@angular/material/badge';
import { MatExpansionModule} from '@angular/material/expansion';

import { JwtInterceptor, ErrorInterceptor } from './_helpers';
import { RestaurarComponent } from './users/restaurar/restaurar.component';
import { DefaultModule } from './users/default.module';
import { NavegacionComponent } from './navegacion/navegacion.component';
import { HeaderComponent } from './navegacion/header/header.component';
import { SidenavComponent } from './navegacion/sidenav/sidenav.component';
import { LayoutModule } from '@angular/cdk/layout';
import { MatAutocompleteModule } from '@angular/material'
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { MatStepperModule} from '@angular/material/stepper';
import { DialogoConfirmacionComponent } from './navegacion/dialogo-confirmacion/dialogo-confirmacion.component';
import { ProductosComponent, ProductosTab1, ProductosTab2,ProductosDialogBundle, ProductosDetalle, ProductosDialog1, ProductosTab3, ProductosTab4, ProductosPublicaciones } from './navegacion/productos/productos.component';
import { CanalesComponent, CanalesTab1, CanalesDetalle, CanalesPublicaciones, CanalesDialogConfirmCreateItem, CanalesDialogLigarProductoItem } from './navegacion/canales/canales.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AvisodeprivacidadComponent } from './navegacion/avisodeprivacidad/avisodeprivacidad.component';
import { ConnectAmazonComponent } from './navegacion/connect-amazon/connect-amazon.component';
import { DialogConfirmationComponent } from './dialog-confirmation/dialog-confirmation.component';
import { AccountsTab7 } from './navegacion/accounts/accounts-tab-7.component';
import { ConfirmarEntradaComponent } from './confirmar-entrada/confirmar-entrada.component';
import { VerOrdenEntradaComponent } from './navegacion/entradas/ver-orden-entrada/ver-orden-entrada.component';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    RegisterComponent,
    ListComponent,
    StatusFfComponent,
    SalesComponent,
    ShopiAuthsComponent,
    InvoicesComponent,
    InvoicesTab1,
    InvoicesTab2,
    InvoicesTab3,
    DialogInvoice,
    TransactionsComponent,
    CedunosComponent,
    CedosComponent,
    CetresComponent,
    BackofficeComponent,
    DialogExampleRestaurar,
    RestaurarComponent,
    NavegacionComponent,
    HeaderComponent,
    SidenavComponent,
    EntradasComponent,
    EntradasTab1,
    EntradasTab2,
    EntradasTab3,
    DialogGuia,
    DialogEditarEntrada,
    FulfillmentsComponent,
    FulfillmentsTab1,
    FulfillmentsTab2,
    FulfillmentsTab3,
    FulfillmentsTab4,
    FulfillmentsTab5,
    DialogFf,
    InventariosComponent,
    InventariosTab1,
    InventariosTab2,
    InventariosTab3,
    DialogInventario,
    DialogGuia2,
    DialogFechaMasiva,
    ReportsComponent,
    ReportsTab1,
    ReportsTab2,
    ReportsTab3,
    DialogReport,
    DialogGuiaFF2,
    DialogGuiaFF3,
    DialogEntrada,
    DialogBundle,
    DialogIntegration,
    IntegrationsComponent,
    IntegrationsTab1,
    IntegrationsTab2,
    IntegrationsTab3,
    AccountsComponent,
    AccountsTab1,
    AccountsTab2,
    AccountsTab3,
    AccountsTab4,
    AccountsTab5,
    DialogAccount,
    DialogIntegration2,
    DialogIntegration4,
    DialogIntegration5,
    DialogIntegration6,
    SupportsComponent,
    SupportsTab1,
    SupportsTab2,
    SupportsTab2,
    DialogGuiaFF4,
    DialogIntegration3,
    DialogFormulario,
    DialogGuiaFF5,
    DialogGuiaFF6,
    InventariosTab4,
    ProductosComponent,
    ProductosTab1,
    CanalesTab1,
    ProductosDialogBundle,
    ProductosDetalle,
    CanalesDetalle,
    CanalesPublicaciones,
    ProductosPublicaciones,
    CanalesDialogConfirmCreateItem,
    CanalesDialogLigarProductoItem,
    DialogoConfirmacionComponent,
    ProductosTab2,
    ProductosDialog1,
    ProductosTab3,
    ProductosTab4,
    DialogAltaCli,
    DialogAltaUser,
    ClientesDialog4,
    UsersDialog5,
    DevolucionsComponent,
    DevolucionsTab1,
    DevolucionsTab2,
    DevolutionsTab3,
    DialogDet1,
    Dialog2,
    DialogDetDevolucion,
    Dialog4,
    DialogImagenes,
    AccountsTab6,
    AccountsTab7,
    DialogAltaRoles,
    UsersDialog6,
    DialogPermisosRoles,
    TicketComponent,
    TicketsTab1,
    TicketsTab2,
    TicketsTab2Sub1,
    TicketsTab2Sub2,
    TicketsTab2Sub3,
    DialogDetTic1,
    DialogPreguntaDevolucion,
    DialogSubirGuia,
    DialogPreguntaFulfillment,
    DialogGuiaFF1,
    DialogGenerarFF,
    DashboardsComponent,
    DialogConfiguracionGeneral,
    DialogPreguntaReabrir,
    CanalesComponent,
    AvisodeprivacidadComponent,
    ConnectAmazonComponent,
    DialogConfirmationComponent,
    FormDataShipmentComponent,
    DialogAltaBox,
    ClientesDialog5,
    AccountsTab8,
    DialogAltaCredential,
    ConfirmarEntradaComponent,
    VerOrdenEntradaComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatNativeDateModule,
    MatTableModule,
    MatFormFieldModule,
    MatSidenavModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatSortModule,
    MatCheckboxModule,
    MatListModule,
    MatDatepickerModule,
    MatInputModule,
    MatMenuModule,
    MatRadioModule,
    MatSelectModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatGridListModule,
    MatSnackBarModule,
    MatDialogModule,
    MatTabsModule,
    MatToolbarModule,
    MatCardModule,
    MatIconModule,
    DefaultModule,
    LayoutModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    MatStepperModule,
    MatDividerModule,
    MatTooltipModule,
    MatBadgeModule,
    MatExpansionModule,
    DragDropModule,
    TranslateModule.forRoot({
      loader:{
        provide    : TranslateLoader,
        useFactory : HttpLoaderFactory,
        deps       : [HttpClient]
      }

    })
  ],
  entryComponents: [
    DialogExampleRestaurar,
    EntradasTab1,
    EntradasTab2,
    EntradasTab3,
    DialogGuia,
    DialogEditarEntrada,
    FulfillmentsTab1,
    FulfillmentsTab2,
    FulfillmentsTab3,
    FulfillmentsTab4,
    FulfillmentsTab5,
    DialogFf,
    InventariosTab1,
    InventariosTab2,
    InventariosTab3,
    DialogInventario,
    DialogGuia2,
    DialogFechaMasiva,
    InvoicesTab1,
    InvoicesTab2,
    InvoicesTab3,
    DialogInvoice,
    ReportsTab1,
    ReportsTab2,
    ReportsTab3,
    DialogReport,
    DialogGuia2,
    DialogGuiaFF2,
    DialogGuiaFF3,
    DialogEntrada,
    DialogBundle,
    DialogIntegration,
    IntegrationsTab1,
    IntegrationsTab2,
    IntegrationsTab3,
    DialogAccount,
    AccountsTab1,
    AccountsTab2,
    AccountsTab3,
    AccountsTab4,
    AccountsTab5,
    IntegrationsTab3,
    DialogIntegration2,
    DialogIntegration4,
    DialogIntegration5,
    DialogIntegration6,
    SupportsTab1,
    SupportsTab2,
    DialogGuiaFF4,
    DialogIntegration3,
    DialogFormulario,
    DialogGuiaFF5,
    DialogGuiaFF6,
    InventariosTab4,
    ProductosTab1,
    CanalesTab1,
    ProductosDialogBundle,
    ProductosDetalle,
    CanalesDetalle,
    CanalesPublicaciones,
    ProductosPublicaciones,
    CanalesDialogConfirmCreateItem,
    CanalesDialogLigarProductoItem,
    DialogoConfirmacionComponent,
    ProductosTab2,
    ProductosDialog1,
    ProductosTab3,
    ProductosTab4,
    DialogAltaCli,
    DialogAltaUser,
    ClientesDialog4,
    UsersDialog5,
    DevolucionsTab1,
    DevolucionsTab2,
    DevolutionsTab3,
    DialogDet1,
    Dialog2,
    DialogDetDevolucion,
    Dialog4,
    DialogImagenes,
    AccountsTab6,
    AccountsTab7,
    DialogAltaRoles,
    UsersDialog6,
    DialogPermisosRoles,
    TicketsTab1,
    TicketsTab2,
    TicketsTab2Sub1,
    TicketsTab2Sub2,
    TicketsTab2Sub3,
    DialogDetTic1,
    DialogPreguntaDevolucion,
    DialogSubirGuia,
    DialogPreguntaFulfillment,
    DialogGuiaFF1,
    DialogGenerarFF,
    DashboardsComponent,
    DialogConfiguracionGeneral,
    DialogPreguntaReabrir,
    DialogConfirmationComponent,
    FormDataShipmentComponent,
    DialogAltaBox,
    ClientesDialog5,
    DialogAltaCredential
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    // Formato de fecha día/mes/año en todos los datepickers (evita confusión con mes/día/año)
    { provide: MAT_DATE_LOCALE, useValue: 'es' },

    // provider used to create fake backend
    // fakeBackendProvider
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function HttpLoaderFactory(http:HttpClient){
  return new TranslateHttpLoader(http);
}
